import {useId} from 'react'
import {clsx} from 'clsx'

import {Text} from '@primer/react-brand/esm'

import {NavLink, type NavLinkType} from '../NavLink/NavLink'

import styles from '../../MarketingNavigation.module.css'

export type NavGroupType = {
  context?: string
  items: NavLinkType[]
  render?: boolean
  hideTitle?: boolean
  title: string
}

export function NavGroup(props: NavGroupType) {
  const {title, items, render = true, hideTitle = false, context} = props
  const titleId = useId()

  if (render === false) {
    return null
  }

  return (
    <div className={styles.Group}>
      <Text
        as="span"
        id={titleId}
        className={clsx(styles.GroupTitle, hideTitle && 'visually-hidden')}
        font="monospace"
        variant="muted"
        size="100"
        weight="medium"
      >
        {title}
      </Text>

      <ul className={clsx(styles.LinkList, items.some(item => item.icon) && styles.IconList)} aria-labelledby={titleId}>
        {items.map(item => (
          <li key={item.title}>
            <NavLink {...item} context={context} />
          </li>
        ))}
      </ul>
    </div>
  )
}
